export class Size {
    constructor(public width: number, public height: number) {}
    //constructor(width: number, height: number) {
    //    this.widthInternal = width;
    //    this.heightInternal = height;
    //}

    //private readonly widthInternal: number;
    //get width(): number {
    //    return this.widthInternal;
    //}

    //private readonly heightInternal: number;
    //get height(): number {
    //    return this.heightInternal;
    //}
}


// WEBPACK FOOTER //
// ./src/app/shared/models/size.ts